var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.recom_resales-all'),"text":_vm.$t('recom_resales.description'),"name":"resales","url":_vm.$listRoutes.recomResales,"table":_vm.resales,"filters":_vm.resalesFilters,"fields":_vm.fields,"defaultFilters":_vm.defaultCreatedAtFilter,"requireFilters":true,"useCurrency":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }